import { PeriodEndPage } from '@/pages/shared/period-end';

export function TravelPeriodEndPage() {
  return <PeriodEndPage app="TRAVEL" />;
}
